import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Aggregator, RangeChartView, WidgetTypes } from '@helpers/Enums';
import { FrequencyType } from '@interfaces/global/config-ehss';
import I18n from '@src/i18n';
import { Popover, Radio } from 'antd';
import React from 'react';
import { Line } from 'react-chartjs-2';

import AditionalContent from './AditionalContent';
import { PopoverContainer, WidgetBox } from './styles';


type PropType = {
  deleteWidgetByIndex: Function,
  unit: string,
  widgetID: string,
  id: string,
  data: string[],
  dataType: string,
  title: string,
  isPreview?: boolean;
  editWidget?: Function;
  min?: any;
  max?: any;
  widget?: any;
  duplicateWidget: Function;
  aggregator: any;
  frequency: any;
  specific: any;
}

type StateType = {
  mode: string,
  data?: any
}

const options = {
  legend: {
    labels: {
      filter: function (item: any, chart: any) {
        return !item.text.includes('range')
      }
    }
  },
  maintainAspectRatio: false,
  responsive: true
}


class RangeChart extends React.Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props)

    this.state = {
      mode: RangeChartView.CHART,
    }
  }
  getStableLines = (number: any) => {
    const resultArray = []
    if (this.props.data && this.props.data.length && this.props.data.length === 1) {
      for (let i = 0; i < 2; i++) {
        resultArray.push(number)
      }
    } else {
      if (this.props.data && this.props.data.length) {
        for (let i = 0; i < this.props.data.length; i++) {
          resultArray.push(number)
        }
      }
    }
    return resultArray;
  }

  shouldComponentUpdate(nextProps: any, NextState: any) {
    return this.props.data !== nextProps.data || this.state.mode !== NextState.mode
  }

  compressArray = (original: any) => {
    let returnedValue: any[] = []
    let arrayUnique = undefined

    if (this.props.widget && this.props.widget.aggregator && this.props.widget.aggregator === Aggregator.SUM || this.props.isPreview && this.props.aggregator === Aggregator.SUM) {
      if (original && original.length > 0) {
        arrayUnique = original.filter(function (item: any, index: any) {
          return original.findIndex((e: any) => e.executedAt == item.executedAt) == index
        })
      }

      if (arrayUnique && arrayUnique.length > 0) {
        for (let unique of arrayUnique) {
          let sum = 0
          for (let arrayItem of original) {
            if (arrayItem.executedAt === unique.executedAt) {
              if (arrayItem.components) {
                let tempSum = arrayItem.components[0].value
                if (tempSum && Array.isArray(tempSum)) {
                  if(tempSum.length > 1){
                    tempSum = tempSum.reduce((a: any, b: any) => Number(a) + Number(b))
                  }else{
                    tempSum = Number(tempSum[0])
                  }
                } else {
                  if(tempSum)
                  tempSum = Number(tempSum)
                }
                !isNaN(tempSum) ? sum += tempSum : null
              }
            }
          }
          returnedValue.push(sum)
        }
      }
    }

    if (this.props.widget && this.props.widget.aggregator && this.props.widget.aggregator === Aggregator.AVG || this.props.isPreview && this.props.aggregator === Aggregator.AVG) {
      if (original && original.length > 0) {
        arrayUnique = original.filter(function (item: any, index: any) {
          return original.findIndex(e => e.executedAt == item.executedAt) == index
        })
      }

      if (arrayUnique && arrayUnique.length > 0) {
        for (let unique of arrayUnique) {
          let sum = 0
          let count = 0
          for (let arrayItem of original) {
            if (arrayItem.executedAt === unique.executedAt) {
              if (arrayItem.components) {
                let tempSum = arrayItem.components[0].value
                if (tempSum && Array.isArray(tempSum)) {
                  if(tempSum.length > 1){
                    tempSum = tempSum.reduce((a: any, b: any) => Number(a) + Number(b))
                  }else{
                    tempSum = Number(tempSum[0])
                  }
                } else {
                  if(tempSum)
                  tempSum = Number(tempSum)
                }
                !isNaN(tempSum) ? sum += tempSum : null
                count += 1
              }
              continue;
            }
          }
          const average = sum / count
          if (average > 0) {
            returnedValue.push(average)
          } else {
            returnedValue.push(0)
          }
        }
      }
    }

    else {

      if (original && original.length > 0) {
        arrayUnique = original.filter(function (item: any, index: any) {
          return original.findIndex(e => e.executedAt == item.executedAt) == index
        })
      }

      let counter = 0
      if (arrayUnique && arrayUnique.length > 0) {
        for (let unique of arrayUnique) {
          counter = 0
          for (let arrayItem of original) {
            if (unique.executedAt === arrayItem.executedAt) {
              counter += 1
            }
          }
          returnedValue.push(counter)
        }
      }

      if (this.props.widget && this.props.widget.recurrence) {
        if (returnedValue && returnedValue.length > 0) {
          returnedValue = returnedValue.map(e => e - 1)
        }
      }
    }
    return returnedValue
  };

  getUnique = (arr: any, comp: string, returnSingleProp?: boolean) => {
    let unique: any
    if (arr) {
      unique = arr
        .map((e: any) => e[comp])
        // store the keys of the unique objects
        .map((e: any, i: any, final: any) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter((e: any) => arr[e]).map((e: any) => arr[e]);

    }
    if (returnSingleProp && unique && unique.length > 0) {
      return unique.map((e: any) => e[comp])
    }
    return unique;
  };

  separateByStatus = (arr: any, labels: any, statusNumber: number) => {
    const usedLabels = labels
    let valArray: any = undefined
    if (arr && arr.length > 0) {
      valArray = arr.map((e: any) => {
        if (e.status === statusNumber) {
          return { executedAt: e.executedAt, components: e.components }
        }
      })
    }
    if (valArray && valArray.length > 0) valArray = valArray.filter((e: any) => e !== undefined)
    let result = this.compressArray(valArray)
    if (result && usedLabels && result.length === 0 && result.length < usedLabels.length) {
      result = []
      while (result.length < usedLabels.length) {
        result.push(0);
      }
    }
    return result
  };

  dataTableFormatter = (data: any) => {
    let header: any = []
    let rows: any = []
    let newData: any


    if (data && data.length > 0) {
      newData = data.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
      for (let item of newData) {
        const date = new Date(item.executedAt)
        const month = I18n.l(date.toLocaleString('default', { month: 'short' }));
        const year = date.toLocaleString('default', { year: '2-digit' });
        const columnDate = header.find((i: string) => i === month)
        if (!columnDate) {
          header.push(`${month}-${year}`)
          if (!rows[`${month}-${year}`]) {
            rows[`${month}-${year}`] = []
          }
        }
        const itemRow = rows[`${month}-${year}`].find((i: any) => i.name === item.owners[0].name)
        const { aggregator } = this.props.isPreview ? this.props : this.props.widget
        if (!itemRow) {
          let value = item.components && item.components[0] && item.components[0].value ? item.components[0].value : 0
          switch (aggregator) {
            case Aggregator.SUM:
              rows[`${month}-${year}`].push({
                name: item.owners[0].name,
                total: Array.isArray(value) && value[0]  ? item.components[0].value[0] : value
              })
              break;
            case Aggregator.AVG:
              rows[`${month}-${year}`].push({
                name: item.owners[0].name,
                total: Array.isArray(value) && value[0]  ? item.components[0].value[0] : value
              })
              break;
            default:
              rows[`${month}-${year}`].push({
                name: item.owners[0].name,
                total: 1
              })
              break;
          }
        } else {
          let value = item.components && item.components[0] && item.components[0].value ? item.components[0].value : 0
          const index = rows[`${month}-${year}`].findIndex((i: any) => i.name === item.owners[0].name)
          switch (aggregator) {
            case Aggregator.SUM:
              rows[`${month}-${year}`][`${index}`].total += Array.isArray(value) && value[0]  ? item.components[0].value[0] : value
              break;
            case Aggregator.AVG:
                rows[`${month}-${year}`][`${index}`].total += Array.isArray(value) && value[0]  ? item.components[0].value[0] : value
                rows[`${month}-${year}`][`${index}`].total /= 2
              break;
            default:
              rows[`${month}-${year}`][`${index}`].total += 1
              break;
          }
        }
      }
    }
    return rows
  }

  getFromToInDays = (fromToObj: any) => {
    if (fromToObj) {
      let from = fromToObj.from
      let to = fromToObj.to
      const daysDiff = (to - from) / (1000 * 60 * 60 * 24)

      return daysDiff
    } else {
      return undefined
    }
  }
  getObjectData = (arr: any) => {
    let diff;
    let frequency;
    let dataType = this.props.dataType;
    let isPreview = this.props.isPreview;
    if (this.props.specific) {
      diff = this.getFromToInDays(this.props.specific);
    }
    if (this.props.frequency) {
      frequency = this.props.frequency
    }
    let objectData = arr;

    if(isPreview && dataType === 'frequency' && frequency && frequency.type === FrequencyType.MONTHS || !isPreview && frequency && frequency.type === FrequencyType.MONTHS || diff && diff > 60 && diff <= 720){
      if (arr && arr.length > 0) {
        objectData = objectData.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
        objectData = objectData.map((e: any) => {
          const date = new Date(e.executedAt)
          const month = I18n.l(date.toLocaleString('default', { month: 'short' }));
          const year = date.toLocaleString('default', { year: '2-digit' });
          return { executedAt: `${month}/${year}`, status: e.status, components: e.components }
        });
      }
    }
    if(isPreview && dataType === 'frequency' && frequency && frequency.type === FrequencyType.DAYS || !isPreview && frequency && frequency.type === FrequencyType.DAYS || diff && diff <= 60 /* && diff >= 2*/){ //limite min comentado juntamente com filtro de horas
      if (arr && arr.length > 0) {
        objectData = objectData.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
        objectData = objectData.map((e: any) => {
          const date = new Date(e.executedAt)
          const month = I18n.l(date.toLocaleString('default', { month: 'short' }));
          const day = I18n.l(date.toLocaleString('default', { day: '2-digit' }));
          return { executedAt: `${day}/${month}`, status: e.status, components: e.components }
        });
      }
    }
    if(frequency && frequency.type === FrequencyType.HOUR || diff && diff <= 2){
      if (arr && arr.length > 0) {
        objectData = arr.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
        objectData = arr.map((e: any) => {
          const date: any = new Date(e.executedAt);
          const datString = date.toLocaleDateString('pt-BR', { dateStyle: 'short' })
          const timString = date.toLocaleTimeString('pt-BR')
          const finalDat = datString.split('/').splice(0, 2).join('/')
          const finalTim = timString.split(':').splice(0, 1).join(':')
          return { executedAt: `${finalDat} - ${finalTim}h`, status: e.status, components: e.components }
        });
      }
    }
    if(frequency && frequency.type === FrequencyType.MINUTES || diff && diff <= 1){
      if (arr && arr.length > 0) {
        objectData = arr.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
        objectData = arr.map((e: any) => {
          const date: any = new Date(e.executedAt);
          const timString = date.toLocaleTimeString('pt-BR')
          const finalTim = timString.split(':').splice(0, 2).join(':')
          return { executedAt: `${finalTim}`, status: e.status, components: e.components }
        });
      }
    }

    if(isPreview && frequency && frequency.type === FrequencyType.YEARS || !isPreview && frequency && frequency.type === FrequencyType.YEARS || diff && diff > 720){
      if (arr && arr.length > 0) {
        objectData = objectData.sort((a: any, b: any) => (a.executedAt > b.executedAt) ? 1 : -1)
        objectData = objectData.map((e: any) => {
          const date = new Date(e.executedAt)
          const year = date.toLocaleString('default', { year: '2-digit' });
          return { executedAt: `${year}`, status: e.status, components: e.components }
        });
      }
    }
    return objectData;
  }


  dataFormatter = (data: any) => {
    const objectData = this.getObjectData(data)
    const labels = this.getUnique(objectData, 'executedAt', true)
    let returnedData = {
      labels: labels,
      datasets: [
        {
          label: I18n.l('processManagement.description.status'),
          data: this.separateByStatus(objectData, labels, 1),
          backgroundColor: '#ECA02F',
          borderColor: '#ECA02F',
          pointHoverBackgroundColor: '#ECA02F',
          pointRadius: 4,
          lineTension: 0.3,
          fill: false
        },
        {
          label: I18n.l('global.taskflow.status.inprogress'),
          data: this.separateByStatus(objectData, labels, 2),
          backgroundColor: '#244245',
          borderColor: '#244245',
          pointHoverBackgroundColor: '#244245',
          pointRadius: 4,
          lineTension: 0.3,
          fill: false
        },
        {
          label: I18n.l('dashboard.values'),
          data: this.separateByStatus(objectData, labels, 3),
          backgroundColor: '#77DEA0',
          borderColor: '#77DEA0',
          pointHoverBackgroundColor: '#77DEA0',
          pointRadius: 4,
          lineTension: 0.3,
          fill: false
        },
        {
          label: I18n.l('processManagement.search.overdue'),
          data: this.separateByStatus(objectData, labels, 5),
          borderColor: '#EC2F2F',
          backgroundColor: '#EC2F2F',
          pointHoverBackgroundColor: '#EC2F2F',
          pointRadius: 4,
          lineTension: 0.3,
          fill: false
        }
      ]
    }

    if (this.props.min) {
      const minRange: any = {
        label: 'min-range',
        fill: 'origin',
        borderColor: 'rgba(250,218,94,0.8)',
        backgroundColor: 'rgba(250,218,94,0.8)',
        pointRadius: 0.1,
        data: this.getStableLines(this.props.min),
      }

      returnedData.datasets.push(minRange)
    }

    if (this.props.max) {
      const maxRange1: any = {
        label: 'max-range',
        fill: 'end',
        borderColor: 'rgba(250,218,94,0.8)',
        backgroundColor: 'rgba(250,218,94,0.8)',
        pointRadius: 0.1,
        data: this.getStableLines(this.props.max),
      }

      returnedData.datasets.push(maxRange1)
    }

    return returnedData
  };

  editWidget() {
    this.props.editWidget()
  }

  duplicateWidget() {
    this.props.duplicateWidget();
  }

  deleteWidget() {
    this.props.deleteWidgetByIndex(this.props.id, this.props.widgetID)
  }

  popoverContent() {
    return (
      <PopoverContainer>
        <div style={{ display: 'flex' }} className="popover-row" onClick={() => this.props.editWidget(this.props)} >
          <div className="icon">
            <FontAwesomeIcon icon={'edit'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.edit')}</p>
          </div>
        </div>

        <div style={{ display: 'flex' }} className="popover-row" onClick={() => this.duplicateWidget()}>
          <div className="icon">
            <FontAwesomeIcon icon={'clone'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.duplicate')}</p>
          </div>
        </div>

        <div style={{ display: 'flex' }} className="popover-row" onClick={() => this.deleteWidget()}>
          <div className="icon">
            <FontAwesomeIcon icon={'trash'} />
          </div>
          <div className="text">
            <p>{I18n.l('common.delete')}</p>
          </div>
        </div>
      </PopoverContainer>
    )

  }


  handleModeChange = async (e: any) => {
    const mode = e.target.value;
    this.setState({ mode })
  };


  renderTable = (data: any) => {
    const header: JSX.Element[] = []
    const rowTable: JSX.Element[] = []
    for (let column in data) {
      header.push(
        <td key={`${column}`}>{column.replace('-', '/')}</td>
      )
    }
    let tdTable: any = []
    for (let column in data) {
      for (let row of data[column]) {
        if (!tdTable[`${row.name}`]) {
          tdTable[`${row.name}`] = []
        }
        for (let c in data) {
          if (!tdTable[`${row.name}`][`${c}`])
            tdTable[`${row.name}`][`${c}`] = 0
        }
        if (!tdTable[`${row.name}`][`${column}`] || tdTable[`${row.name}`][`${column}`] === 0) {
          tdTable[`${row.name}`][`${column}`] = row.total
        }
      }
    }
    for (let r in tdTable) {
      const colTable: JSX.Element[] = []
      colTable.push(<td className="first" key={`col-first-${r}`}>{r}</td>)
      for (let c in tdTable[r]) {
        colTable.push(<td key={`${r}-${c}`}>{tdTable[r][c]}</td>)
      }
      rowTable.push(<tr key={`tr-${r}`}>{colTable}</tr>)
    }
    return (
      <table>
        <thead>
          <tr>
            <td className="first"></td>
            {header}
          </tr>
        </thead>
        <tbody>
          {rowTable}
        </tbody>
      </table>
    )
  }


  render() {
    const data = this.dataFormatter(this.props.data)
    const tableData = this.dataTableFormatter(this.props.data)
    return (
      <WidgetBox className={`-barChart ${this.props.isPreview ? "-preview" : ''}`}>
        <div className="up">
          <div className="title">
            {this.props.title}
          </div>
          {!this.props.isPreview &&
            <div className="edit no-padding">
              <Popover
                placement='bottom'
                trigger="hover"
                content={this.popoverContent()}
              >
                <FontAwesomeIcon icon={"cog"} />
              </Popover>
            </div>
          }
        </div>
        <div className={`bottom`}>
          <div className="buttons-chart">
            <Radio.Group onChange={this.handleModeChange} value={this.state.mode} style={{ marginBottom: 8 }}>
              <Radio.Button value={RangeChartView.CHART}>{I18n.l('widgets.charts.chart.view')}</Radio.Button>
              <Radio.Button value={RangeChartView.TABLE}>{I18n.l('wigdets.charts.detailed.data')}</Radio.Button>
            </Radio.Group>
          </div>
          <AditionalContent type={WidgetTypes.LINE_CHART} widget={this.props.widget} isPreview={this.props.isPreview} count={this.props.data ? this.props.data.length : 0} />
          <div
            className={`canvasChart ${this.state.mode === RangeChartView.CHART ? "active" : "desactive"}`}
          >
            <span className="rotated-text">{I18n.l('widget.execution.number')}</span>
            <Line options={options} data={data} />
          </div>
          <div className={`tableChart ${this.state.mode === RangeChartView.TABLE ? "active" : "desactive"}`}>
            {this.renderTable(tableData)}
          </div>
        </div>
      </WidgetBox>
    )
  }
}

export default RangeChart

